var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"text-align":"center","margin-top":"25vh","font-size":"5rem"}},[_vm._v("404")])}
var staticRenderFns = []

export { render, staticRenderFns }